export default "__VITE_ASSET__7759473a__"